export default __webpack_public_path__ + "static/media/6-react.48809612.png";